import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { useAuth } from "./AuthContext";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const Ctx = createContext(null);
export const useEntitlements = () => useContext(Ctx);

export const EntitlementsProvider = ({ children }) => {
  const { user } = useAuth();
  const [ent, setEnt] = useState(null);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    if (!user) { setEnt(null); setLoading(false); return; }
    try {
      const r = await fetch(`${API}/growth/entitlements`, { credentials: "include" });
      if (r.ok) setEnt(await r.json());
    } catch { /* ignore */ } finally { setLoading(false); }
  }, [user]);

  useEffect(() => { setLoading(true); refresh(); }, [refresh]);

  // Route/feature access. While loading (ent null) we allow, to avoid a lock flash.
  const allow = useCallback((key) => {
    if (!ent) return true;
    if (ent.full_access) return true;
    const f = ent.features || {};
    if (key === "ai_journal" || key === "analytics") return !!f.full_journal;
    if (key === "news_pro") return !!f.news_pro;
    if (key === "community" || key === "ws_vip") return !!f.vip_community;
    // command_center, ai_chart, ai_coach, leaderboard, share_card → broker-only
    return false;
  }, [ent]);

  return (
    <Ctx.Provider value={{ ent, loading, refresh, allow }}>
      {children}
    </Ctx.Provider>
  );
};
